import React from "react"
import { useSelector } from "react-redux"
import ColorPicker from "@/signomatic/components/color_picker"
import PatternToolbox from "@/signomatic/components/pattern_toolbox"
import Toolbox from "@/signomatic/components/toolbox"
import { type ToolboxStripItemProps } from "@/signomatic/components/toolbox_strip"
import { type State } from "@/signomatic/store/reducers"

const ColorToolbox: React.FC<ToolboxStripItemProps> = ({ sign }) => {
  const subToolbox = useSelector<State, string | null>(({ subToolbox }) => subToolbox)

  return (
    <Toolbox tKey="color">
      {subToolbox !== "customcolor" && <ColorPicker sign={sign} />}
      {subToolbox === "patterns" && <PatternToolbox sign={sign} />}
    </Toolbox>
  )
}

export default ColorToolbox
